export default "__VITE_ASSET__022e6da4__"